import { Notify } from "./Notify";
import { INotifyProps } from "./Notify/types";
import { Skeleton } from "./Skeleton";

export const Mock = {
    Notify: ({showme}: INotifyProps) => <Notify showme={showme} />,
    Skeleton: () => <Skeleton />
}